import { useLoaderData, useLocation } from "react-router-dom";

import Colors from "../../../components/global/Colors";
import DynamicSection from "../../../components/modules/FollowUps/modules/FormBuilder/DynamicSection";
import Svg from "../../../components/ui library/components/svgs/standard/svg";
import Container from "../../../components/modules/FollowUps/modules/FormBuilder/DetailBase/Container";

const Template = () => {
  const lastSegment = useLocation()?.pathname.split("/").pop();
  const { mockedData } = useLoaderData();

  return (
    <Container
      namePage={lastSegment}
      icon={
        <Svg
          name="his-person"
          color={Colors.blue[700]}
          sx={{ width: "1.5rem" }}
        />
      }
    >
      <DynamicSection data={mockedData} />
    </Container>
  );
};

export default Template;
